import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    n: '01',
    title: 'We learn your goal.',
    body: 'CPA, CPC, or brand awareness — you tell us the number that matters and we build the plan around it.',
  },
  {
    n: '02',
    title: 'We place your media.',
    body: 'Using our proprietary first-party audience data, we reach net-new buyers across the open web — beyond the walled gardens where everyone else is bidding against you.',
  },
  {
    n: '03',
    title: 'We start small. Then we scale.',
    body: 'Most agencies believe in aim, ready, fire. Sellrly believes in ready, aim, fire. We prove the model before we ask you to fund a bigger media plan.',
  },
  {
    n: '04',
    title: 'We manage everything.',
    body: 'Strategy, placement, optimization, reporting. You get results — not another dashboard to babysit.',
  },
];

export default function HowItWorks({ id = 'how-it-works', titleCase = false }) {
  return (
    <section id={id} className="relative py-24 md:py-32 bg-white text-[#031D44]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-4xl">
          <p className="text-sm sm:text-base font-semibold uppercase tracking-[0.22em] text-[#FF5081]">How it works</p>
          <h2 className={`mt-5 font-display text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-[-0.025em] leading-[1.02] text-[#031D44] ${titleCase ? 'capitalize' : ''}`}>
            Four lines, kept simple.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="rounded-2xl p-8 md:p-9 border border-[#031D44]/10 bg-[#F8F7FC] hover:border-[#031D44]/20 transition-colors"
            >
              <div className="flex items-baseline gap-5">
                <span className="font-display text-4xl md:text-5xl font-semibold text-[#FF5081]/80 leading-none tabular-nums">
                  {s.n}
                </span>
                <h3 className="font-display text-xl md:text-[22px] font-semibold tracking-tight text-[#031D44]">
                  {s.title}
                </h3>
              </div>
              <p className="mt-5 text-[#031D44]/65 leading-relaxed text-[15px] md:text-base max-w-xl">{s.body}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 max-w-3xl">
          <p className="text-lg lg:text-xl leading-relaxed text-[#031D44]/70">
            No briefing delays. No markup on top of markup. No three-week turnarounds. You talk to the people actually
            running your media.
          </p>
        </div>
      </div>
    </section>
  );
}
